import { render, staticRenderFns } from "./AffiliationSummary.vue?vue&type=template&id=bb4acbf8"
import script from "./AffiliationSummary.vue?vue&type=script&lang=js"
export * from "./AffiliationSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports